// 增加开票人存储数据pinia
const addTaxUserStore = () => {
    const userAnswer = ref([])
    return {
        userAnswer,
    }
}
export const useTaxUserStore = defineStore('addTaxUserStore', addTaxUserStore,
    /*{
        persist: {
            enabled: true,
            storage: sessionStorage
        }
    }*/)
